import React from "react";

const items = [
  "🚨 ATENDIMENTO 24 HORAS",
  "🚗 TROCA DE ESTEPE",
  "🔋 CARGA DE BATERIA",
  "🔑 CHAVEIRO AUTOMOTIVO",
  "🛞 BORRACHARIA MÓVEL",
  "⛽ AUXÍLIO COMBUSTÍVEL",
  "🛡️ ANJO DA GUARDA",
  "⚡ CHEGADA RÁPIDA",
  "✅ PREÇO JUSTO",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative bg-[#f3bd0e] text-black border-y-4 border-black overflow-hidden py-4"
    >
      <div className="flex marquee-track whitespace-nowrap">
        {row.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6 font-display text-base sm:text-lg uppercase tracking-tight"
          >
            <span>{it}</span>
            <span className="inline-block w-1.5 h-1.5 bg-black rotate-45"></span>
          </div>
        ))}
      </div>
    </div>
  );
}
